
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background">
      <div className="text-center max-w-md px-4">
        <h1 className="text-6xl font-bold bg-gradient-linear from-recallio-yellow to-recallio-green bg-clip-text text-transparent mb-6">
          404
        </h1>
        <p className="text-xl text-foreground mb-8">
          Oops! We couldn't find the page you're looking for.
        </p>
        <div className="bg-recallio-dark-gray p-6 rounded-lg border border-recallio-light-gray/50 mb-8">
          <code className="text-sm font-geist-mono text-muted-foreground">
            {`Error: Memory not found for path '${location.pathname}'`}
          </code>
        </div>
        <Button asChild className="btn-primary">
          <a href="/" className="inline-flex items-center gap-2">
            <Home size={16} />
            Return to Dashboard
          </a>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
